import React from 'react';
import GlobalStyles from '@mui/material/GlobalStyles';

const GlobalCss: React.FC = () => <GlobalStyles styles={{ '.pac-container': { zIndex: 1400 } }} />;

export default GlobalCss;
